@let stufe = aktuell();
@if (status() !== 'bereit') {
  <app-details-historie-status [status]="status()" [fehlerText]="fehlerText()" (retry)="retry.emit()" />
} @else {
  @if (stufe) {
    <div class="uebergabe-panel__stand" [class.uebergabe-panel__stand--abgeschlossen]="closed()">
      <app-avatar [name]="stufe.displayName" [size]="28" />
      <div class="uebergabe-panel__stand-text">
        <div class="uebergabe-panel__stand-label">
          {{
            (closed() ? 'common.detailsHistorie.uebergabe.abgeschlossen' : 'common.detailsHistorie.uebergabe.liegtBei')
              | translate
          }}
        </div>
        <div class="uebergabe-panel__stand-name">
          {{ stufe.displayName }}
          <span class="uebergabe-panel__stand-seit">
            · {{ 'common.detailsHistorie.uebergabe.seit' | translate: { zeit: seit(stufe) | date: zeitMuster } }}
          </span>
        </div>
      </div>
      @if (!readonly()) {
        <div class="uebergabe-panel__aktionen">
          @if (closed()) {
            <button
              #wiederOeffnenKnopf
              type="button"
              class="uebergabe-panel__knopf uebergabe-panel__knopf--wieder-oeffnen"
              [attr.data-testid]="testIdPrefix() + '-uebergabe-wieder-oeffnen'"
              [attr.aria-disabled]="gesperrt() ? 'true' : null"
              [matTooltip]="disabledReason() ?? ''"
              (click)="wiederOeffnen()"
            >
              {{ 'common.detailsHistorie.uebergabe.wiederOeffnen' | translate }}
            </button>
          } @else {
            <ng-container [ngTemplateOutlet]="uebergebenVorlage" />
            <button
              type="button"
              class="uebergabe-panel__knopf uebergabe-panel__knopf--abschliessen"
              [attr.data-testid]="testIdPrefix() + '-uebergabe-abschliessen'"
              [attr.aria-disabled]="gesperrt() ? 'true' : null"
              [matTooltip]="disabledReason() ?? ''"
              (click)="abschliessen()"
            >
              <mat-icon class="uebergabe-panel__icon" aria-hidden="true">check</mat-icon>
              {{ 'common.detailsHistorie.uebergabe.abschliessen' | translate }}
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <div class="uebergabe-panel__leer">
      <p class="uebergabe-panel__leer-text">{{ 'common.detailsHistorie.uebergabe.leer' | translate }}</p>
      @if (!readonly()) {
        <ng-container [ngTemplateOutlet]="uebergebenVorlage" />
      }
    </div>
  }

  @if (formularOffen() && !readonly() && !(closed() && stufe)) {
    <div class="uebergabe-panel__formular" [id]="formularId()">
      <app-person-select
        class="uebergabe-panel__person"
        variant="bundle"
        [formControl]="personControl"
        [label]="'common.detailsHistorie.uebergabe.uebergebenAn' | translate"
        [options]="personOptions()"
        [allowNone]="false"
      />
      <div class="uebergabe-panel__nachricht-feld">
        <label class="uebergabe-panel__nachricht-label" [for]="nachrichtId()">
          @if (empfaenger(); as person) {
            {{ 'common.detailsHistorie.uebergabe.nachrichtAn' | translate: { vorname: vorname(person.displayName) } }}
          } @else {
            {{ 'common.detailsHistorie.uebergabe.nachricht' | translate }}
          }
          @if (messageRequired()) {
            <span class="uebergabe-panel__pflicht" aria-hidden="true">*</span>
          }
        </label>
        <textarea
          class="uebergabe-panel__textarea"
          rows="3"
          [class.uebergabe-panel__textarea--fehler]="nachrichtFehlt()"
          [id]="nachrichtId()"
          [attr.aria-required]="messageRequired() ? 'true' : null"
          [attr.aria-invalid]="nachrichtFehlt() ? 'true' : null"
          [attr.aria-describedby]="nachrichtFehlt() ? nachrichtFehlerId() : null"
          [attr.maxlength]="nachrichtMax"
          [placeholder]="platzhalter() || ('common.detailsHistorie.uebergabe.platzhalter' | translate)"
          [value]="nachricht()"
          (input)="nachrichtGeaendert($event)"
        ></textarea>
        @if (nachrichtFehlt()) {
          <p class="uebergabe-panel__nachricht-fehler" role="alert" [id]="nachrichtFehlerId()">
            {{ 'common.detailsHistorie.uebergabe.nachrichtPflicht' | translate }}
          </p>
        }
        @if (vorlagen().length) {
          <div
            class="uebergabe-panel__vorlagen"
            role="group"
            [attr.aria-label]="'common.detailsHistorie.uebergabe.vorlagen' | translate"
          >
            @for (vorlage of vorlagen(); track vorlage) {
              <button
                type="button"
                class="uebergabe-panel__vorlage"
                [attr.aria-disabled]="gesperrt() ? 'true' : null"
                (click)="vorlageAnhaengen(vorlage)"
              >
                ＋ {{ vorlage }}
              </button>
            }
          </div>
        }
      </div>
      <div class="uebergabe-panel__fuss">
        <label class="uebergabe-panel__benachrichtigen">
          <input
            #benachrichtigenFeld
            type="checkbox"
            class="uebergabe-panel__checkbox"
            [checked]="benachrichtigen()"
            (change)="benachrichtigen.set(benachrichtigenFeld.checked)"
          />
          {{ 'common.detailsHistorie.uebergabe.benachrichtigen' | translate }}
        </label>
        <button
          type="button"
          class="uebergabe-panel__sekundaer"
          [attr.aria-disabled]="gesperrt() ? 'true' : null"
          (click)="abbrechen()"
        >
          {{ 'common.cancel' | translate }}
        </button>
        <button
          type="button"
          class="uebergabe-panel__primaer"
          [attr.data-testid]="testIdPrefix() + '-uebergabe-absenden'"
          [attr.aria-disabled]="absendenGesperrt() ? 'true' : null"
          [matTooltip]="uebergebenGrund()"
          (click)="absenden()"
        >
          <mat-icon class="uebergabe-panel__icon uebergabe-panel__icon--primaer" aria-hidden="true">
            chevron_right
          </mat-icon>
          {{ 'common.detailsHistorie.uebergabe.uebergeben' | translate }}
        </button>
      </div>
    </div>
  }
  @if (errorMessage()) {
    <p class="uebergabe-panel__fehler" role="alert">{{ errorMessage() }}</p>
  }

  @if (stufe) {
    <div class="uebergabe-panel__kette-label" [id]="ketteId()">
      {{ 'common.detailsHistorie.uebergabe.kette' | translate }}
    </div>
    <ol class="uebergabe-panel__kette" [attr.aria-labelledby]="ketteId()">
      @for (eintrag of chain(); track eintrag.stageId; let letzte = $last) {
        <li class="uebergabe-panel__stufe">
          @if (!letzte) {
            <span class="uebergabe-panel__linie" aria-hidden="true"></span>
          }
          <app-avatar [name]="eintrag.displayName" [size]="24" />
          <div class="uebergabe-panel__stufe-inhalt">
            <div class="uebergabe-panel__stufe-kopf">
              <span
                class="uebergabe-panel__stufe-name"
                [class.uebergabe-panel__stufe-name--aktiv]="istAktiv(eintrag)"
                [class.uebergabe-panel__stufe-name--uebersprungen]="eintrag.skipped"
              >
                {{ eintrag.displayName }}
              </span>
              @if (istAktiv(eintrag)) {
                <span class="uebergabe-panel__badge uebergabe-panel__badge--aktuell">
                  {{ 'common.detailsHistorie.uebergabe.aktuell' | translate }}
                </span>
              }
              @if (eintrag.skipped) {
                <span class="uebergabe-panel__badge uebergabe-panel__badge--uebersprungen">
                  {{ 'common.detailsHistorie.uebergabe.uebersprungen' | translate }}
                </span>
              }
              <span class="uebergabe-panel__stufe-meta">
                @if (eintrag.handedOverByName?.trim()) {
                  {{
                    'common.detailsHistorie.uebergabe.von'
                      | translate
                        : { vorname: vorname(eintrag.handedOverByName), zeit: eintrag.createdAt | date: zeitMuster }
                  }}
                } @else {
                  {{
                    'common.detailsHistorie.uebergabe.erstellt'
                      | translate: { zeit: eintrag.createdAt | date: zeitMuster }
                  }}
                }
              </span>
              @if (istAktiv(eintrag) && ueberspringbar() && !readonly()) {
                <button
                  type="button"
                  class="uebergabe-panel__ueberspringen"
                  [attr.data-testid]="testIdPrefix() + '-uebergabe-ueberspringen'"
                  [attr.aria-label]="
                    'common.detailsHistorie.uebergabe.ueberspringenAria' | translate: { name: eintrag.displayName }
                  "
                  [attr.aria-disabled]="gesperrt() ? 'true' : null"
                  [matTooltip]="
                    disabledReason() || ('common.detailsHistorie.uebergabe.ueberspringenTooltip' | translate)
                  "
                  (click)="ueberspringen(eintrag)"
                >
                  {{ 'common.detailsHistorie.uebergabe.ueberspringen' | translate }}
                </button>
              }
            </div>
            @if (eintrag.message?.trim()) {
              <p class="uebergabe-panel__nachricht" [class.uebergabe-panel__nachricht--aktiv]="istAktiv(eintrag)">
                {{ eintrag.message }}
              </p>
            }
          </div>
        </li>
      }
    </ol>
  }
}

<ng-template #uebergebenVorlage>
  <button
    #uebergebenKnopf
    type="button"
    class="uebergabe-panel__knopf uebergabe-panel__knopf--uebergeben"
    [attr.data-testid]="testIdPrefix() + '-uebergeben'"
    [attr.aria-expanded]="formularOffen()"
    [attr.aria-controls]="formularOffen() ? formularId() : null"
    [attr.aria-disabled]="uebergebenGesperrt() ? 'true' : null"
    [matTooltip]="uebergebenGrund()"
    (click)="formularUmschalten()"
  >
    <mat-icon class="uebergabe-panel__icon" aria-hidden="true">chevron_right</mat-icon>
    {{ 'common.detailsHistorie.uebergabe.uebergeben' | translate }}
  </button>
</ng-template>
